// extracted by mini-css-extract-plugin
export var breadcrumb = "_18-0";
export var breadcrumbArrow = "_18-1";